import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f40b7672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center align-center wrap" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "flex align-start grow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/search.svg" }, null, -1))
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = { class: "flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeButton = _resolveComponent("SeButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("textarea", {
          oninput: "this.value = this.value.replace(/\\n/g,'')",
          ref: "searchInput",
          style: {"resize":"none","width":"100%","height":"19px","overflow":"hidden"},
          onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSearchChange && _ctx.onSearchChange(...args))),
          placeholder: _ctx.getPlaceholder(),
          class: "search-input",
          type: "text"
        }, null, 40, _hoisted_5)
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.modelValue != null)
        ? (_openBlock(), _createBlock(_component_ToggleSwitch, {
            key: 0,
            modelValue: _ctx.displayUnactives,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.displayUnactives) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("display-unactives")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.btnText != null)
        ? (_openBlock(), _createBlock(_component_SeButton, {
            key: 1,
            ref: "newBtn",
            onPress: _ctx.newClicked,
            style: {"height":"50px"},
            icon: "/ico/plus.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.btnText), 1)
            ]),
            _: 1
          }, 8, ["onPress"]))
        : _createCommentVNode("", true)
    ])
  ]))
}